import axios from 'axios'
import { MessageBox } from 'element-ui';
// import { globalInfo } from '../environment'
// import { CookieUtils } from './cookie.utils'

export class HttpUtils {
  static debounce = true
  static get(path, opts = {}, isFilter = true) {
    let DEFAULT_POST_OPTS = {
      headers: {},
    }
    if(opts.params && isFilter){
      opts.params = this.filterParam(opts.params)
    }
    return new Promise((resolve, reject) =>{
      axios
        .get(path, {...opts, ...DEFAULT_POST_OPTS})
        .then(response => {
          if(path.indexOf('/post/quickedit') !== -1){
            resolve(response.data)
          }else{
            this.handleResponseCode(response, () =>{
              resolve(response.data)
            })
          }
        })
        .catch( error => {
          console.log('catch')
          reject(error)
        })
    })
  }

  static post(path, data = null, opts = {}, isFilter = true) {
    let DEFAULT_POST_OPTS = {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      },
    }
    if(data && isFilter){
      data = this.filterParam(data)
    }
    opts = { ...DEFAULT_POST_OPTS, ...opts }
    return new Promise((resolve, reject) =>{
      axios
        .post(path, data, opts)
        .then(response => {
          // 提交/发布文章 单独处理
          if(path.indexOf('/post/put') !== -1 ){
            resolve(response.data)
          }else{
            this.handleResponseCode(response, () =>{
              resolve(response.data)
            })
          }
        })
        .catch(error => {
          console.log('catch')
          reject(error)
      })
    })
  }

  static uploadFile(path, formData) {
    return HttpUtils.post(path, formData, {
      'Content-Type': 'multipart/form-data'
    })
  }

  static handleResponseCode(resp, callback){
    if(resp.data.code !== 0 ){
      if(HttpUtils.debounce){
        HttpUtils.debounce = false
        // let msg = '系统错误，请联系管理员或稍后再试。'
        // if(resp.data.code == 400 || resp.data.code == 401 || resp.data.code == 403 ||  resp.data.code == 10404){
        //   msg = decodeURIComponent(resp.data.msg)
        // }
        let msg = decodeURIComponent(resp.data.msg)
        if(resp.data.code == 500){
          msg = '系统错误，请联系管理员或稍后再试。'
        }
        MessageBox.alert(`${msg}`, 'This is an error message', {
          type: 'error',
          confirmButtonText: '确定',
          callback: () => {
            HttpUtils.debounce =true
            if(resp.data.code == 401){
              window.location.href = resp.data.attach.location
            }
            
          }
        });
      }
      // return
    }
    callback && callback()
  }


  static filterParam(query) {
    Object.keys(query).forEach(item => {
      if (
        query[item] === null ||
        query[item] === undefined ||
        query[item] === ''
      ) {
        delete query[item]
      }
    })
    return query
  }

}
